var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniTransport02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.574219,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#C275A3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_500_12505",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.574219,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#3D529B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_500_12505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.395 181.58C113.395 178.266 116.081 175.58 119.395 175.58H141.73C145.044 175.58 147.73 178.266 147.73 181.58V209.36C147.73 212.674 145.044 215.36 141.73 215.36H119.395C116.081 215.36 113.395 212.674 113.395 209.36V181.58Z",
    fill: "#2C190E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.77 52.3231C188.958 51.3899 189.778 50.7188 190.73 50.7188H224.441C225.393 50.7188 226.213 51.3899 226.401 52.3231L229.476 67.5574H185.695L188.77 52.3231Z",
    fill: "#532626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.737 71.2451C133.265 68.4031 135.745 66.3418 138.636 66.3418H275.604C278.494 66.3418 280.974 68.4031 281.502 71.2451L294.093 138.968H120.146L132.737 71.2451Z",
    fill: "#389282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.092 138.968L281.502 71.2451C280.973 68.4031 278.493 66.3418 275.603 66.3418H141.762L187.327 138.968H294.092Z",
    fill: "#246B5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.884 63.5075V54.6309H197.219C199.254 54.6309 200.339 55.8692 200.345 57.5734C200.339 59.2715 199.242 60.5037 197.194 60.5037H195.478V63.5075H193.884ZM195.478 59.1918H196.973C198.175 59.1856 198.714 58.5113 198.714 57.5734C198.714 56.6232 198.175 55.9673 196.973 55.9673H195.478V59.1918Z",
    fill: "#913A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.111 63.6056C201.583 63.6056 201.148 63.1765 201.154 62.6492C201.148 62.1343 201.583 61.7113 202.111 61.7052C202.619 61.7113 203.055 62.1343 203.055 62.6492C203.055 63.1765 202.619 63.6056 202.111 63.6056Z",
    fill: "#913A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.636 63.5075V54.6309H207.971C210.006 54.6309 211.091 55.8692 211.098 57.5734C211.091 59.2715 209.994 60.5037 207.947 60.5037H206.23V63.5075H204.636ZM206.23 59.1918H207.726C208.927 59.1856 209.467 58.5113 209.467 57.5734C209.467 56.6232 208.927 55.9673 207.726 55.9673H206.23V59.1918Z",
    fill: "#913A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.881 54.6309V63.5075H212.311V54.6309H213.881Z",
    fill: "#913A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.331 63.6424C216.327 63.6424 215.095 62.306 215.095 60.2217C215.095 58.1619 216.345 56.7642 218.245 56.7642C219.876 56.7642 221.286 57.7879 221.286 60.1236V60.614H216.639C216.664 61.7481 217.332 62.4224 218.344 62.4163C219.03 62.4224 219.49 62.1282 219.692 61.7297H221.225C220.943 62.8822 219.876 63.6424 218.331 63.6424ZM216.645 59.5473H219.79C219.784 58.6401 219.171 57.978 218.27 57.978C217.332 57.978 216.701 58.7014 216.645 59.5473Z",
    fill: "#913A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.83 76.849C139.18 74.9516 140.835 73.5742 142.764 73.5742H271.474C273.404 73.5742 275.058 74.9516 275.408 76.849L286.86 138.968H127.379L138.83 76.849Z",
    fill: "#97BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.86 138.968L275.409 76.849C275.059 74.9516 273.404 73.5742 271.475 73.5742H146.271L188.678 138.968H286.86Z",
    fill: "#799993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.146 138.969H294.092L308.558 153.734H105.681L120.146 138.969Z",
    fill: "#42AE9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.681 153.734H308.558V187.43C308.558 192.953 304.08 197.43 298.558 197.43H115.681C110.158 197.43 105.681 192.953 105.681 187.43V153.734Z",
    fill: "#389281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.557 187.43V153.734H142.663L198.799 197.43H298.557C304.08 197.43 308.557 192.953 308.557 187.43Z",
    fill: "#286559"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.095,
    y: 169.432,
    width: 66.9829,
    height: 19.921,
    fill: "#532626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.078 169.432H174.095V178.286L188.531 189.353H241.078V169.432Z",
    fill: "#3E1616"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.304,
    y: 172.551,
    width: 60.5639,
    height: 13.6828,
    fill: "#784444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.868 172.551H177.304V180.725L184.704 186.234H237.868V172.551Z",
    fill: "#673737"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_500_12505)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 130.563,
    cy: 179.487,
    r: 9.86443,
    fill: "#532626"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.884 183.763V174.887H197.219C199.254 174.887 200.339 176.125 200.345 177.829C200.339 179.527 199.242 180.76 197.194 180.76H195.478V183.763H193.884ZM195.478 179.448H196.973C198.175 179.442 198.714 178.767 198.714 177.829C198.714 176.879 198.175 176.223 196.973 176.223H195.478V179.448Z",
    fill: "#4B0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.111 183.861C201.583 183.861 201.148 183.432 201.154 182.905C201.148 182.39 201.583 181.967 202.111 181.961C202.619 181.967 203.055 182.39 203.055 182.905C203.055 183.432 202.619 183.861 202.111 183.861Z",
    fill: "#4B0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.636 183.763V174.887H207.971C210.006 174.887 211.091 176.125 211.098 177.829C211.091 179.527 209.994 180.76 207.947 180.76H206.23V183.763H204.636ZM206.23 179.448H207.726C208.927 179.442 209.467 178.767 209.467 177.829C209.467 176.879 208.927 176.223 207.726 176.223H206.23V179.448Z",
    fill: "#4B0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.881 174.887V183.763H212.311V174.887H213.881Z",
    fill: "#4B0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.331 183.898C216.327 183.898 215.095 182.562 215.095 180.478C215.095 178.418 216.345 177.02 218.245 177.02C219.876 177.02 221.286 178.044 221.286 180.379V180.87H216.639C216.664 182.004 217.332 182.678 218.344 182.672C219.03 182.678 219.49 182.384 219.692 181.986H221.225C220.943 183.138 219.876 183.898 218.331 183.898ZM216.645 179.803H219.79C219.784 178.896 219.171 178.234 218.27 178.234C217.332 178.234 216.701 178.957 216.645 179.803Z",
    fill: "#4B0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.284 110.22C124.222 109.718 123.796 109.342 123.291 109.342H120.147L122.578 126.826L125.622 121.098L124.284 110.22Z",
    fill: "#389281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.885 109.342H115.059C112.368 109.342 110.187 111.523 110.187 114.214V114.214C110.187 116.905 112.368 119.086 115.059 119.086H122.885V109.342Z",
    fill: "#389281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.885 111.012C122.885 110.889 122.785 110.789 122.662 110.789H115.059C113.167 110.789 111.633 112.323 111.633 114.215V114.215C111.633 116.107 113.167 117.64 115.059 117.64H122.662C122.785 117.64 122.885 117.541 122.885 117.418V111.012Z",
    fill: "#97BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.242 242.711V222.914H190.008C194.506 222.914 197.09 225.689 197.09 229.586C197.09 233.537 194.465 236.258 189.898 236.258H186.344V242.711H182.242ZM186.344 232.949H189.242C191.676 232.949 192.865 231.582 192.852 229.586C192.865 227.617 191.676 226.291 189.242 226.277H186.344V232.949ZM201.055 242.957C199.77 242.957 198.73 241.932 198.758 240.66C198.73 239.402 199.77 238.377 201.055 238.391C202.271 238.377 203.324 239.402 203.324 240.66C203.324 241.932 202.271 242.957 201.055 242.957ZM206.66 242.711V222.914H214.426C218.924 222.914 221.508 225.689 221.508 229.586C221.508 233.537 218.883 236.258 214.316 236.258H210.762V242.711H206.66ZM210.762 232.949H213.66C216.094 232.949 217.283 231.582 217.27 229.586C217.283 227.617 216.094 226.291 213.66 226.277H210.762V232.949ZM228.07 222.914V242.711H224.023V222.914H228.07ZM237.941 243.012C233.389 242.998 230.6 240.059 230.613 235.355C230.6 230.775 233.43 227.672 237.777 227.672C241.674 227.672 244.75 230.133 244.75 235.191V236.34H234.605C234.605 238.582 235.932 239.963 238.023 239.977C239.404 239.963 240.389 239.361 240.785 238.473H244.641C244.066 241.221 241.605 242.998 237.941 243.012ZM234.605 233.797H240.922C240.908 231.992 239.664 230.693 237.859 230.707C236 230.693 234.688 232.088 234.605 233.797Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_500_12505",
    x: 120.698,
    y: 169.623,
    width: 20.2285,
    height: 20.2285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.745833 0 0 0 0 0.279687 0 0 0 0 0.279687 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_500_12505"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniTransport02);
export default __webpack_public_path__ + "static/media/mini_transport_02.2ee6c2a7fe5a6985a56bf799684b49d0.svg";
export { ForwardRef as ReactComponent };